import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { useEffect, useRef } from "react";
import { heroBg, heroMbBg } from "../utils";
export default function Hero({ theme, isMobile }) {
  const bannerCount = 10; // 图片数量
  const imgRef = useRef(null);

  const getSrc = (index) =>
    `/assets/images/banner/${
      theme === "dark" ? `banner${index + 1}.png` : `/light/banner${index + 1}.png`
    }`;

  useEffect(() => {
    // 初始化 dark class
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    // 初始化 opacity = 0
    gsap.set(imgRef.current, { opacity: 0, backgroundImage: `url(${getSrc(0)})`});

    const timeline = gsap.timeline({ repeat: -1 });
    for (let i = 0; i < bannerCount; i++) {

      // 淡入 + 切换图片
      timeline.to(imgRef.current, {
        duration: 2,
        opacity: 1,
        onStart: () => {
          gsap.set(imgRef.current, { backgroundImage: `url(${getSrc(i)})` });
        },
      });

      // 停留
      timeline.to(imgRef.current, { duration: 2, opacity: 1 });

      // 淡出
      timeline.to(imgRef.current, { duration: 1, opacity: 0 });
    }

    return () => {
      timeline.kill();
    };
  }, [theme]);

  useGSAP(() => {
    gsap.to("#hero", { opacity: 1, delay: 0 });
    gsap.to("#cta", { opacity: 1, y: -50, delay: 2 });
  }, []);

  return (
    <section
      id="hero"
      className="w-full sm:nav-height nav-mb-height relative dark:bg-black transition-colors duration-1000 sm:pt-[156px]"
      style={{background:`url(${isMobile?heroMbBg:heroBg}) no-repeat`,backgroundSize:'cover'}}
    >
      <div className="h-full w-full flex-center flex-col pt-[100px] sm:pt-0">
        <p
          className={theme === "dark" ? "hero-title translate-y-10 sm:-translate-y-10" : "hero-title-light translate-y-10 sm:-translate-y-10"}
          style={{ fontSize: "48px", fontFamily: "Pang" }}
        >
          智能警示镜
        </p>

        <div className="flex flex-center justify-around w-full sma:h-[85%] overflow-hidden">
          <div  
            ref={imgRef}
            className="sm:h-[680px] h-[500px] sm:scale-100 scale-[1.3] w-full mx-auto bg-center bg-contain bg-no-repeat select-none"
          ></div>
        </div>
      </div>

      <div id="cta" className="flex flex-col items-center opacity-0 translate-y-20">
      </div>
    </section>
  );
}
